import React from 'react'

const paymentLogos: any = {
    '1': {
        logo: 'mit.png',
        secondaryLogo: 'santander.png',
        redirectable: true,
        name: 'MIT',
        allowClabe: false,
    },
    '2': {
        logo: 'santander.png',
        redirectable: false,
        allowClabe: false,
        beneficiario: 'Beneficiario:  Inle Owo, S. de R.L. de C.V.',
    },
    '3': {
        logo: 'bbva.png',
        redirectable: false,
        allowClabe: false,
        beneficiario: 'Beneficiario:  Inle Owo, S. de R.L. de C.V.',
    },
    '4': {
        logo: 'stp.png',
        redirectable: false,
        allowClabe: true,
        beneficiario: 'Beneficiario:  Inle Owo, S. de R.L. de C.V.',
    },
    '5': {
        logo: 'bbva.png',
        redirectable: false,
        allowClabe: true,
    },
    '8': {
        logo: 'stripe.png',
        redirectable: true,
        name: 'Stripe',
        allowClabe: false,
    },
    '9': {
        logo: 'stripe.png',
        redirectable: true,
        name: 'Stripe',
        allowClabe: false,
    },
    '10': {
        logo: 'stripe.png',
        secondaryLogo: 'oxxo.jpeg',
        redirectable: true,
        name: 'Stripe Oxxo',
        allowClabe: false,
    }
};

const context = process.env.PUBLIC_URL

export default function PaymentWay(props: any) {
    const { paymentWays } = props
    const paymentKeys = Object.keys(paymentWays)

    const onClickToPay = (url: string) => {
        window.open(url, '_blank')
    }
    return (
        <div>
            <div className="text-center text-3xl">
                Selecciona tu forma de pago
            </div>
            {
                paymentKeys.map((it) =>
                    <div className="max-w-6xl text-center rounded overflow-hidden shadow-lg m-16">
                        <img alt="Logo" src={`${context}/img/${paymentLogos[`${it}`].logo}`} style={{ width: '25%', margin: 'auto' }} />
                        {paymentLogos[`${it}`].secondaryLogo && <img alt="Logo" src={`${context}/img/${paymentLogos[`${it}`].secondaryLogo}`} style={{ width: (`${it}` === '10') ? '9%' : '25%', margin: 'auto' }} />}
                        <div className="px-6 py-4">
                            {(`${it}` !== '10') && <div className="font-bold text-xl mb-2">
                                {paymentLogos[`${it}`].redirectable && <img src={`${context}/img/brand.png`} style={{ width: '25%', margin: 'auto' }} alt="Logo de tarjetas" />}
                            </div>}
                            {(paymentLogos[`${it}`].redirectable) &&
                                <button
                                    className="w-full bg-red-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                                    type="button"
                                    onClick={() => onClickToPay(paymentWays[it].uri)}>
                                    Pagar con {paymentLogos[`${it}`].name}
                                </button>}
                            {(`${it}` !== '5' && !paymentLogos[`${it}`].redirectable) &&
                                <div>
                                    <p>{paymentLogos[`${it}`].beneficiario}</p>
                                    <p>{paymentWays[it].convenio}</p>
                                    {paymentLogos[`${it}`].allowClabe && <p>Clabe: {paymentWays[it].clabe}</p>}
                                    <p>Referencia: {paymentWays[it].referencia}</p>
                                </div>
                            }

                            {(`${it}` === '5' && !paymentLogos[`${it}`].redirectable) &&
                                <div>
                                    <div>
                                        <p className="text-xl">Transferencia directa</p>
                                        <textarea
                                            className="w-full"
                                            disabled={true}
                                            style={{ minHeight: '150px' }}
                                        >
                                            {paymentWays[it].banco_directo}
                                        </textarea>

                                    </div>
                                    <div>
                                        <p className="text-xl">Transferencia por banco intermediario</p>
                                        <textarea
                                            style={{ minHeight: '298px' }}
                                            className="w-full"
                                            disabled={true}
                                        >
                                            {paymentWays[it].banco_intermediario}
                                        </textarea>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>)
            }
        </div>
    )
}
